import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const useLoadingValueComponent = () => usePropertyContext().LoadingValueComponent;